import { Navigate, useLocation } from 'react-router-dom'

/** The SMS Agent dashboard moved to Agents → SMS. Links keep their params (`?tab=Ops`). */
export default function SMSAgentRedirect() {
  const { search } = useLocation()
  return <Navigate to={`/agents/sms${search}`} replace />
}
